import React, { Component } from 'react';

export default class Dashboard extends Component {

	constructor(props) {
    super(props);
    this.state = {};
  }

	render() {
		console.log('dashboard', this.state);
		return (
      <h1>Dashboard</h1>
		);
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard.jsx